export enum ProfileMenuItemStatus {
	DEFAULT = 'default',
	SUCCESS = 'success',
	ERROR = 'error',
}
